module.exports = __webpack_public_path__ + "img/factura.c4fc16ce.svg";